import React from "react";

const Notice = ({ returning }) => {
  return returning ? (
    <div
      className="alert well-sm alert-warning"
      role="alert"
      style={{ marginTop: "15px", marginBottom: "0", fontWeight: "bolder" }}
    >
      It appears that your organization participated in Champions{" "}
      <span style={{ fontStyle: "italic" }}>fore</span> Charity last year, and
      as such we have pre-populated the sections of the charity registration
      form with last year’s data. Please click on each section and confirm or
      make changes to your information as needed.
    </div>
  ) : (
    <div
      className="alert well-sm alert-warning"
      role="alert"
      style={{ marginTop: "15px", marginBottom: "0", fontWeight: "bolder" }}
    >
      Thank you for your interest in participating in Champions{" "}
      <span style={{ fontStyle: "italic" }}>fore</span> Charity, in addition to
      completing the information in each of the sections below, please have your
      current W9 (dated Oct. 2018 in top left corner), 501(c)(3) letter and your
      organization’s logo in EPS, JPG and/or PNG formats to upload in the
      documents section.
    </div>
  );
};

export default Notice;
